// extracted by mini-css-extract-plugin
export var truncate = "_b-0";